module.exports = __webpack_public_path__ + "static/img/wariant2.810e41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/wariant2.png
// module id = PECI
// module chunks = 1